import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const BREAKPOINTS = ["xl", "lg", "md", "sm", "xs"];

const Col: React.FC<any> = ({ className, children, ...props }) => {
  const classes: string[] = [];
  const spans = [];

  BREAKPOINTS.forEach((breakpoint) => {
    let propValue = props[breakpoint];
    delete props[breakpoint];

    let span, offset, order;
    if (propValue != null && typeof propValue === "object") {
      ({ span = true, offset, order } = propValue);
    } else {
      span = propValue;
    }

    let infix = breakpoint !== "xs" ? `-${breakpoint}` : "";

    if (span != null)
      spans.push(span === true ? `col${infix}` : `col${infix}-${span}`);

    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });

  if (!spans.length) {
    spans.push("col");
  }

  return (
    <div className={classNames(...spans, ...classes, className)}>
      {children}
    </div>
  );
};

const column = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.shape({
    size: PropTypes.number,
    offset: PropTypes.number,
  }),
]);

Col.propTypes = {
  xs: column,
  sm: column,
  md: column,
  lg: column,
  xl: column,
};

export default Col;
